export default {
  ADD_BASIC_INFO: (state, payload) =>
    (state.basicInfo = Object.assign({}, { ...payload.basicInfo })),
  SET_BASIC_INFO: (state, payload) =>
    (state.basicInfo = Object.assign({}, state.basicInfo, { ...payload })),
  PARSE_BASIC_INFO: (state, payload) =>
    (state.basicInfo = Object.assign({}, state.basicInfo, { ...payload })),
  ADD_PHOTO_FILE: (state, payload) =>
    (state.basicInfo.photo_file = { ...payload }),
  ADD_UPDATE_PHOTO_URL: (state, payload) =>
    (state.basicInfo.photo_url = payload),
  ADD_CURRICULUM_URL: (state, payload) =>
    (state.basicInfo.curriculum_url = payload),
  CLEAR_BASIC_INFO_STATE: state => (state.basicInfo = {}),

  store: (state, payload) =>
    (state.basicInfo = Object.assign({}, { ...payload })),

  updateName: (state, name) => (state.basicInfo = { ...state.basicInfo, name }),

  updateEmail: (state, email) =>
    (state.basicInfo = { ...state.basicInfo, email })
};
